import { lazy, Suspense } from "react";

import RouteLoadingIndicator from "../RouteLoadingIndicator/RouteLoadingIndicator";

const LazyComponent = lazy(() => import("./DeclinedView.component"));

const DeclinedView = () =>
  <Suspense fallback={<RouteLoadingIndicator />}>
    <LazyComponent />
  </Suspense>;

export default DeclinedView;
